import React from 'react';
import HeroSlideshow from '../components/HeroSlideshow';
import IndustryPartners from '../components/IndustryPartners';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import BeforeAfterSection from '../components/BeforeAfterSection';
import PromoBanner from '../components/PromoBanner';
import ReviewsSection from '../components/ReviewsSection';
import CTABoxes from '../components/CTABoxes';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <>
      <HeroSlideshow />
      <PromoBanner />
      <IndustryPartners />
      <AboutSection />
      <ServicesSection />
      <BeforeAfterSection />
      <ReviewsSection />
      <CTABoxes />
      <ContactSection />
    </>
  );
};

export default HomePage;
